import ReactGa from "react-ga4";

const dispatchGoogleAnalyticsEvent = (category: string, eventName: string, label: string, data: object) => {
  if (process.env.ENV_IS_PRODUCTION !== "true") return;

  ReactGa.event(eventName, {
    category,
    label,
    ...data,
  });
};

export default dispatchGoogleAnalyticsEvent;
